let fontSize = 1;

window.toggleAccMenu = function() {
  const menu = document.getElementById('accessibility-menu');
  if (menu) menu.classList.toggle('open');
};

window.toggleAccClass = function(className, btnId) {
  document.documentElement.classList.toggle(className);
  const btn = document.getElementById(btnId);
  if (btn) btn.classList.toggle('active');
};

window.adjustText = function(factor) {
  fontSize *= factor;
  if (fontSize > 2.5) fontSize = 2.5;
  if (fontSize < 0.7) fontSize = 0.7;
  
  // Apply to documentElement (HTML) so it scales the whole site
  document.documentElement.style.fontSize = (fontSize * 100) + '%';
  
  // Add a helper class to body to handle responsive scaling
  document.body.classList.add('acc-is-scaling');
};

window.resetAcc = function() {
  document.documentElement.className = '';
  document.documentElement.style.fontSize = '';
  document.body.classList.remove('acc-is-scaling');
  fontSize = 1;
  document.querySelectorAll('.acc-btn').forEach(b => b.classList.remove('active'));
};

// Close menu when clicking outside
window.addEventListener('click', function(event) {
  const menu = document.getElementById('accessibility-menu');
  const trigger = document.getElementById('accessibility-trigger');
  if (menu && trigger && !menu.contains(event.target) && !trigger.contains(event.target)) {
    menu.classList.remove('open');
  }
});
